import { requester } from "App";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useEffect, useState } from "react";


function VendorInventoryControll() {
    const [products, setProducts] = useState([]);
    const { userName } = useContext(AuthContext);

    useEffect(() => {
        let data = { vendorName: userName }
        if (userName) {
            
            requester.findAllByVendor(data, (result) => {
            
                setProducts(result.data)
            })
        }

    }, [userName])
    const Card = (props) => {
        const { data } = props;
        return (
            <div style={{ display: "flex", flex: "1 1 min(200px, 33%)" }}>
                <FlexChild>
                    <VerticalFlex>
                        <FlexChild>
                            <img src={data.productImg} />
                        </FlexChild>
                        <FlexChild>
                            {data.productName}
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </div>
        );


    }
    // 중첩된 객체 포함 모든 키를 추출하는 함수
    const extractHeaders = (data) => {
        const headersSet = new Set();
        data &&
            data.forEach(item => {
                Object.keys(item).forEach(key => {
                    if (key !== 'id') { // 'password' 키는 제외
                        if (typeof item[key] === 'object' && item[key] !== null) {
                            Object.keys(item[key]).forEach(subKey => {
                                headersSet.add(`${key}.${subKey}`);
                            });
                        } else {
                            headersSet.add(key);
                        }
                    }
                });
            });
        return Array.from(headersSet);
    };
    const headers = extractHeaders(products && products);

    // 중첩된 데이터 접근 함수
    const getNestedValue = (item, path) => {
        const keys = path.split('.');
        let result = item;
        for (let key of keys) {
            result = result[key];
        }
        return result;
    };
    const styles = {
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            boxShadow: '0 2px 3px rgba(0, 0, 0, 0.1)',
        },
        th: {
            backgroundColor: '#f0f0f0',
            color: '#333',
            fontWeight: 'bold',
            padding: '10px',
            border: '1px solid #ccc',
            textAlign: 'left',
        },
        td: {
            padding: '8px',
            border: '1px solid #ccc',
            textAlign: 'left',
        },
    };
    return (

        <VerticalFlex gap={30}>
            <FlexChild>
                <P size={40} font={"gmarketSansBold"}>상품 리스트</P>
            </FlexChild>
            <FlexChild>
                <div style={{ overflowX: 'auto' }}>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                {/* 테이블 헤더 */}
                                {headers.map((header) => (
                                    <th style={styles.th} key={header}>{header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {/* 데이터 행 */}
                            {products && products.map((item, index) => (
                                <tr key={index}>
                                    {headers.map((header) => (
                                        <td style={styles.td} key={`${index}-${header}`}>
                                            {header === 'productImg' && getNestedValue(item, header) ? (
                                                <img src={getNestedValue(item, header)} alt="Product" style={{ maxWidth: '100px', maxHeight: '100px' }} />
                                            ) : (
                                                getNestedValue(item, header)
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </FlexChild>
        </VerticalFlex>

    );
}

export default VendorInventoryControll;